import {EWabaStatus} from '../Channels/definitions';
import {EFormSteps, EPublicStatus, EStatus, LOGO_SIZE} from './definitions';

const activeStatus = {
  title: 'Active',
  messageTitle: 'Active',
  messageContent:
    'Your channel is registered. You can now use it to communicate with recipients. ' +
    'To increase the channel’s daily limit to 2,000 messages and display your account name in chats with recipients, meet one of the recommended requirements:',
  reason1: 'Send 2,000 template messages within 30 days.',
  reason2: 'Verify the business in Meta. ',
  link: 'Verification instructions.',
};

export default {
  whatsAppBusinessApp: 'WhatsApp Business App',
  businessAppPostfix: ' Business App',
  steps: {
    [EFormSteps.SETTINGS]: 'Registration requirements and channel settings',
    [EFormSteps.VIEW]: 'Account representation',
  },
  marketingMessagesApi: 'MM API',
  clarifyForm: {
    title: '{{name}} channel data',
    confirmTitle: 'Save changes?',
    confirmMessage: 'Channel pricing and internal channel name cannot be changed after saving',
    cancelTitle: 'Cancel changes?',
    cancelMessage:
      'Save the selected channel pricing so that the customer\'s channel switches to the "Correct" status',
  },
  editForm: {
    name: 'Internal channel name',
    nameHint: 'This name will be displayed in the edna Pulse channel list and in reports',
    tariff: 'Channel pricing',
    address: 'Company address',
    email: 'Company e-mail address',
    status: 'WhatsApp account status',
    logo: 'Company logo',
    logoHint: `Your company logo in JPG or JPEG format, with a minimum size of ${LOGO_SIZE}×${LOGO_SIZE}px. You can edit this parameter through edna technical support after registering the channel.`,
    baseHint:
      'You can edit this parameter through edna technical support after registering the channel.',
    settingsBlock: 'Channel settings',
    viewBlock: 'Account representation',
    viewBlockHint:
      'Your customers will see this information when viewing the profile of this WhatsApp account.',
    phone: 'Phone number to which the channel is registered',
    phoneHint: 'This phone number is provided when registering your WhatsApp Business Account.',
    facebookHint:
      'To register a WhatsApp channel, sign in to your Facebook account and follow the suggested steps. Registration usually takes about 5 minutes.',
    facebookPostpaidHint:
      '<strong>Warning!</strong> The license is activated immediately after registration and requires payment for the current month. If you are not ready to start working, save the draft and return to the registration process later.',
    facebookPrepaidHint:
      '<strong>Warning!</strong> Immediately after successful registration, the balance will be charged <strong>{{connectionPrice}} {{connectionCurrency}}</strong> for connecting the channel, <strong>{{initPrice}} {{initCurrency}}</strong> for the license from <strong>{{initStart}}</strong> to <strong>{{initEnd}}</strong>. Top up your balance if the amount is insufficient. The next charge for the license will be <strong>{{renewalStart}}</strong> in the amount of <strong>{{renewalPrice}} {{renewalCurrency}}</strong>. If you are not ready to start working, save the draft and return to the registration process later.',
    facebookVatHint: 'Amounts include VAT and are calculated for the current day.',
  },
  techPartner: {
    code: 'Registration link',
    codeHint:
      'Copy and send this link to the customer to complete the WhatsApp channel registration',
  },
  regenerateCodeModal: {
    title: 'Update registration link?',
    subTitle: 'The current link becomes invalid and a new one is created after the update',
  },
  publicForm: {
    title:
      'This page allows you to register a {{channel}} channel. Your provider {{partnerName}} will receive information about the registration',
    helpTitle: 'Conditions required for registration:',
    helpSteps: [
      'You have a personal Facebook account.',
      "You have a phone number to register a WhatsApp account. The number shouldn't be associated with any other WhatsApp accounts.",
      'You can receive an SMS message or accept an international call to the specified phone number to confirm it.',
    ],
    successTitle: 'Channel sent for registration',
    successHint:
      'To check the registration status, contact your provider <br/><0>{{partnerName}}</0>',
    errorTitle:
      '{{channel}} channel registration is not available at this link:<br/><0>{{error}}</0>',
    errorHint: 'To get a new link, contact your provider<br/><0>{{partnerName}}</0>',
    errors: {
      [EPublicStatus.ERROR_USED_CODE]: 'channel is already registered at this link',
      [EPublicStatus.ERROR_INCORRECT_TARIFF]:
        'wrong connection conditions specified for the channel',
      [EPublicStatus.ERROR_OLD_CODE]: 'the link has expired',
      unknown: "this page doesn't exist",
    },
    facebookTerms: 'By clicking Continue with Facebook, you agree to the <0>terms of service</0>',
    businessAppLogin:
      'To register a WhatsApp Business App channel, sign in to your Facebook account and follow \nthe suggested steps.',
  },
  adblockStatus: {
    info: "You've disabled pop-up blocking extensions or browser settings.",
    adblockDetected:
      'An Adblock extension is enabled on your device to block pop-ups. To continue, disable the extension.',
    popupsDetected:
      "It's possible that your browser has pop-up blocking or an Adblock extension enabled. To continue, change your browser settings or disable the extension.",
    notDetected:
      "We haven't found any blocking settings enabled. If the Facebook window doesn't open, check your browser settings and extensions.",
    retry: 'Recheck',
  },
  facebookAvailability: {
    info: 'Your device opens the Facebook website.',
    error:
      'Your device can’t open the Facebook website.\nTo continue, establish a connection with the website',
    loading: 'Establishing a connection with the website',
    retry: 'Recheck',
  },
  imageErrors: {
    invalidLogoFormat: 'Invalid logo format',
  },
  status: {
    [EStatus.UI_NEED_TARIFF_TEMPLATE_ID]: {
      title: 'Requires attention',
      messageTitle: 'Select channel pricing',
      messageContent:
        'Your customer {{name}} has submitted the channel for registration. To complete the registration, select the channel pricing. You can change the internal channel name before saving the channel pricing.',
    },
    [EStatus.DRAFT]: {title: 'Draft'},
    [EStatus.NEW]: {title: 'New'},
    [EStatus.DELETED]: {title: 'Disabled'},
    [EStatus.DONE_BUSINESS_VERIFICATION]: activeStatus,
    [EStatus.BUSINESS_VERIFICATION_EXPIRED]: activeStatus,
    [EStatus.DONE_FINISH_REGISTER]: {
      title: 'Active',
      messageTitle: 'Active',
      messageContent:
        'You have completed Business Verification with Meta, and your channel is registered. You now have higher daily limits for sending template messages and can display your account name in chats with recipients',
    },
    [EStatus.SENT_TO_PLATFORM]: {
      title: 'Pending registration',
      messageTitle: 'Pending registration',
      messageContent: 'Your channel is being registered on Facebook and will be available soon.',
    },
    [EStatus.CANCELLED]: {
      title: 'Disabled',
      messageTitle: 'Disabled',
    },
    [EStatus.DISABLED]: {
      title: 'Disabled',
      messageTitle: 'Disabled',
    },
  },
  wabaStatus: {
    [EWabaStatus.ACCOUNT_RESTRICTION]: {
      messageTitle: 'Channel is limited (WABA)',
      messageContent:
        'WhatsApp Business account {{wabaId}} to which this channel belongs has been restricted due to activity that violates the WhatsApp Business Terms of Service. {{reason}}<b>Outgoing messages cannot be sent until {{expirationDate}}</b>. The channel is only available to receive incoming messages.' +
        '<br/><br/>To submit an appeal, <0>follow the recommendations</0>.',
      wabaRestrictionReason: 'The reason is {{violationType}}. ',
    },
    [EWabaStatus.DISABLED]: {
      messageTitle: 'Disabled',
      messageContent:
        'WhatsApp Business account {{wabaId}} to which this channel belongs has been disabled due to activity that violates the WhatsApp Business Terms of Service. The channel has stopped working.' +
        '<br/><br/>To submit an appeal, <0>follow the recommendations</0>.',
    },
  },
  businessAppForm: {
    helpTitle: 'Make sure you have everything required to register a WhatsApp channel:',
    helpPoint:
      'You need an active WhatsApp Business App account on the number you want to connect, and admin access to a Meta Business Portfolio.',
    moreInfo: 'Learn more about Business Portfolio',
  },
  businessAppSuccessModal: {
    title: 'Your WhatsApp Business App is being connected',
    description:
      'We will start importing your contacts and chat history from the WhatsApp Business App once the connection is complete. This may take some time. You will be notified once the import is complete.',
    submitButton: 'Cool!',
  },
  businessAppBanner: {
    title: 'Benefits of connecting your WhatsApp Business App:',
    points: [
      'Connect your existing number without changing it or losing chat history.',
      'Continue using WhatsApp Business App while unlocking API capabilities (automation, integrations, team access).',
      'Messages are synchronized between the app and edna Pulse, keeping conversations consistent.',
      'Fast setup with no complex technical configuration.',
    ],
    requirements: 'Requirements',
    requirementsInfo:
      'You need an active WhatsApp Business App account on the number you want to connect, and admin access to a Meta Business Portfolio.',
  },
};
